const useAmenities = () => {
    const amenities = [
        "Clothing Rack", "Dryer", "Swimming Pool", "Garden Pieces"
    ];
    return amenities;
}

export default useAmenities;